var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"social-link",on:{"click":_vm.setStep}},[_c('img',{attrs:{"src":_vm.imageUrl,"alt":_vm.name,"width":"20"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }